export default __webpack_public_path__ + "static/media/Affiliate_banner.a1c38fcc.png";